class TranslateService {
  constructor() {
    this.cache = new Map();
    this.proxyUrl = process.env.REACT_APP_AI_PROXY_URL || '/api/ai-proxy';
  }

  alreadyInTarget(text, targetLanguage) {
    const hasCjk = /[\u3400-\u9fff]/.test(text || '');
    return targetLanguage === 'zh-TW' ? hasCjk : !hasCjk;
  }

  async translate(text, targetLanguage = 'zh-TW') {
    if (!text || this.alreadyInTarget(text, targetLanguage)) {
      return { translated: text, isTranslated: false };
    }
    const key = `${targetLanguage}:${text}`;
    if (this.cache.has(key)) return { translated: this.cache.get(key), isTranslated: true, fromCache: true };

    const target = targetLanguage === 'zh-TW' ? 'Traditional Chinese used in Taiwan' : 'English';
    const response = await fetch(this.proxyUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        messages: [
          { role: 'system', content: `Translate restaurant reviews into ${target}. Return only the translation and preserve the original meaning.` },
          { role: 'user', content: text }
        ]
      })
    });
    if (!response.ok) throw new Error('翻譯服務暫時無法使用');
    const data = await response.json();
    const translated = data.response?.trim();
    if (!translated) throw new Error('沒有收到翻譯結果');
    this.cache.set(key, translated);
    return { translated, isTranslated: true };
  }

  translateToEnglish(text) {
    return this.translate(text, 'en');
  }
}

export default new TranslateService();
